import { Badge, Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { CustomTabPanel, a11yProps } from "../../components/TabPanel/TabPanel";
import {
  useCustomToast,
  ToastVariant,
} from "../../components/Methods/SnackBar";
import AddDataPoints from "./AddDataPoints";
import ReviewDataPoints from "./ReviewDataPoints";

const ViewAllDataPoints = ({ switchToFillDataPointTab }: any) => {
  const [value, setValue] = React.useState(0);

  const showToast = useCustomToast();
  const handleShowToast = (
    message: string,
    variant: ToastVariant,
    isCloseable: boolean
  ) => {
    showToast(message, variant, isCloseable);
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = event.currentTarget.innerHTML;
    const tabLabel = tempElement.innerText;

    // Clean up the temporary element
    tempElement.remove();
    setValue(newValue);
    
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "100%", // Adjust the height as needed
        }}
      >
        <Box
          sx={{
            minWidth: 110, // Set the width for the left sidebar
            bgcolor: "background.paper",
          }}
        >
          <Tabs
            centered
            value={value}
            onChange={handleChange}
            orientation="vertical"
            textColor="inherit"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
          >
            <Tab {...a11yProps(0)} label={"Add"} />
            <Tab {...a11yProps(1)} label={"Review"}></Tab>
          </Tabs>
        </Box>
        <Box
          sx={{
            flex: 1,
            // display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CustomTabPanel index={0} value={value}>
            <AddDataPoints
              switchToFillDataPointTab={switchToFillDataPointTab}
            />
          </CustomTabPanel>
          <CustomTabPanel index={1} value={value}>
            <ReviewDataPoints />
          </CustomTabPanel>
        </Box>
      </Box>
    </>
  );
};

export default ViewAllDataPoints;
